const IndianFlagSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 600" className="w-5 h-3.5 shrink-0 rounded-[2px] shadow-xs">
    <rect width="900" height="200" fill="#FF9933"/>
    <rect y="200" width="900" height="200" fill="#FFFFFF"/>
    <rect y="400" width="900" height="200" fill="#128807"/>
    <g transform="translate(450,300)">
      <circle r="92" fill="none" stroke="#000080" stroke-width="6.5"/>
      <circle r="16" fill="#000080"/>
      <path d="M0,0 L0,-92 M0,0 L0,92 M0,0 L-92,0 M0,0 L92,0 M0,0 L-46,-80 M0,0 L46,80 M0,0 L-80,-46 M0,0 L80,46 M0,0 L-80,46 M0,0 L80,-46 M0,0 L-46,80 M0,0 L46,-80 M0,0 L-24,-89 M0,0 L24,89 M0,0 L-65,-65 M0,0 L65,65 M0,0 L-89,-24 M0,0 L89,24 M0,0 L-89,24 M0,0 L89,-24 M0,0 L-65,65 M0,0 L65,-65 M0,0 L-24,89 M0,0 L24,-89" stroke="#000080" stroke-width="4"/>
    </g>
  </svg>
);

window.Header = function Header({ 
  activeTab, 
  setActiveTab, 
  openQuoteModal,
  categoriesList = ['All', 'Railways', 'Industrial Automation', 'Aerospace', 'Automotive', 'Custom CAD & Fixtures'],
  selectedProductCategory,
  setSelectedProductCategory,
  setSelectedIndustrySlug,
  setSelectedSolutionSlug
}) {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const [industriesDropdownOpen, setIndustriesDropdownOpen] = React.useState(false);
  const [productsDropdownOpen, setProductsDropdownOpen] = React.useState(false);

  const defaultNavMenu = [
    { id: 'home', label: 'Home', target: 'home', type: 'link', visible: true },
    { 
      id: 'industries', 
      label: 'Industries', 
      target: 'industries', 
      type: 'dropdown', 
      visible: true,
      items: [
        { id: 'railway', label: 'Railway Testing Systems & Rigs', target: 'railway', visible: true },
        { id: 'automotive', label: 'Automotive Test & Automation', target: 'automotive', visible: true },
        { id: 'aerospace', label: 'Aerospace Test Systems & GSE', target: 'aerospace', visible: true },
        { id: 'industrial', label: 'Industrial Automation & SPM', target: 'industrial', visible: true },
        { id: 'rd', label: 'R&D & Academic Research', target: 'rd', visible: true }
      ]
    },
    { 
      id: 'products', 
      label: 'Products', 
      target: 'products', 
      type: 'dropdown', 
      visible: true,
      items: [] 
    },
    { id: 'about', label: 'About', target: 'about', type: 'link', visible: true },
    { id: 'blogs', label: 'Insights', target: 'blogs', type: 'link', visible: true },
    { id: 'careers', label: 'Careers', target: 'careers', type: 'link', visible: true },
    { id: 'contact', label: 'Contact / RFQ', target: 'contact', type: 'link', visible: true }
  ];

  const mergeNavMenu = (loadedMenu) => {
    if (!Array.isArray(loadedMenu) || loadedMenu.length === 0) return defaultNavMenu;
    const merged = [...loadedMenu];
    
    // Check if careers is missing
    const careersItem = merged.find(item => item.id === 'careers');
    if (!careersItem) {
      const contactIdx = merged.findIndex(item => item.id === 'contact');
      if (contactIdx !== -1) {
        merged.splice(contactIdx, 0, { id: 'careers', label: 'Careers', target: 'careers', type: 'link', visible: true });
      } else {
        merged.push({ id: 'careers', label: 'Careers', target: 'careers', type: 'link', visible: true });
      }
    } else {
      careersItem.visible = true;
    }
    
    // Check and remove india link if it exists in DB data
    const indiaIdx = merged.findIndex(item => item.id === 'india');
    if (indiaIdx !== -1) {
      merged.splice(indiaIdx, 1);
    }
    
    // Force products to dropdown
    const productsItem = merged.find(item => item.id === 'products');
    if (productsItem) {
      productsItem.type = 'dropdown';
    }
    
    return merged;
  };

  const [navMenu, setNavMenu] = React.useState(defaultNavMenu);
  const [solutions, setSolutions] = React.useState([]);
  const [industries, setIndustries] = React.useState([]);

  React.useEffect(() => {
    fetchNavMenu();
    const handleSync = () => fetchNavMenu();
    window.addEventListener('novatek_content_updated', handleSync);
    window.addEventListener('storage', handleSync);
    return () => {
      window.removeEventListener('novatek_content_updated', handleSync);
      window.removeEventListener('storage', handleSync);
    };
  }, []);

  const fetchNavMenu = async () => {
    try {
      const res = await window.apiClient.get('content.php');
      if (res.success && res.data) {
        if (res.data.nav_menu) {
          setNavMenu(mergeNavMenu(res.data.nav_menu));
        }
        if (res.data.solutions_data) setSolutions(res.data.solutions_data);
        if (res.data.industries_data) setIndustries(res.data.industries_data);
      } else {
        setNavMenu(defaultNavMenu);
      }
    } catch (e) {
      console.warn('Navbar CMS sync warning:', e);
      setNavMenu(defaultNavMenu);
    }
  };

  // Only render visible items
  const visibleNavItems = navMenu.filter(item => item.visible !== false);

  return (
    <header className="bg-white sticky top-0 border-b border-slate-200 z-50 shadow-sm transition-all">
      <nav className="flex items-center justify-between w-full px-4 sm:px-6 lg:px-8 h-20">
        
        {/* Left Side: Brand Logo + Navigation Links */}
        <div className="flex items-center gap-6 xl:gap-8 h-full">
          {/* Official Brand Logo */}
          <div 
            onClick={() => { setActiveTab('home'); setMobileMenuOpen(false); }} 
            className="flex items-center gap-3 cursor-pointer group py-2 shrink-0 pr-2"
          >
            <img 
              src="/logo.png" 
              alt="NOVATEK Logo" 
              width="250"
              height="100"
              className="h-11 sm:h-12 w-auto object-contain transition-transform group-hover:scale-105" 
            />
          </div>

          {/* Desktop Dynamic Navigation Links */}
          <div className="hidden xl:flex items-center gap-4 lg:gap-5 h-full">
            {visibleNavItems.map((item) => {
              // 1. Dropdown item
              if (item.type === 'dropdown') {
                const isItemActive = activeTab === item.target || 
                  (item.target === 'products' && (activeTab === 'products' || activeTab === 'product-detail'));

                let dropdownSubItems = (item.items || []).filter(sub => sub.visible !== false);
                if (item.id === 'products') {
                  dropdownSubItems = categoriesList
                    .filter(cat => cat !== 'All')
                    .map(cat => ({
                      id: cat.toLowerCase().replace(/[^a-z0-9]+/g, '-'),
                      label: cat,
                      target: cat
                    }));
                }

                return (
                  <div key={item.id} className="relative group py-6">
                    <button
                      onClick={() => setActiveTab(item.target)}
                      className={`flex items-center gap-0.5 font-sans text-[14px] transition-colors cursor-pointer ${
                        isItemActive ? 'text-secondary font-bold' : 'text-slate-700 hover:text-secondary font-medium'
                      }`}
                    >
                      <span>{item.label}</span>
                      <span className="material-symbols-outlined text-[18px]">expand_more</span>
                    </button>
                    {dropdownSubItems.length > 0 && (
                      <div className="absolute top-[80%] left-0 hidden group-hover:block bg-white border border-slate-200 rounded-xl shadow-2xl py-2 min-w-[260px] z-50 animate-fadeIn">
                        {dropdownSubItems.map((sub) => (
                          <button
                            key={sub.id || sub.target}
                            onClick={() => {
                              const targetSlug = sub.target || sub.id;
                              let foundType = null;
                              
                              if (item.id === 'products' || (targetSlug && targetSlug.startsWith('products:'))) {
                                const catName = targetSlug.startsWith('products:') ? targetSlug.replace('products:', '') : sub.label;
                                if (setSelectedProductCategory) setSelectedProductCategory(catName);
                                setActiveTab('products');
                              } else {
                                if (industries && industries.some(i => i.slug === targetSlug || i.id === targetSlug)) {
                                if (setSelectedIndustrySlug) setSelectedIndustrySlug(targetSlug);
                                foundType = 'industries';
                              }

                              if (foundType) {
                                setActiveTab(foundType);
                                } else if (targetSlug) {
                                  setActiveTab(targetSlug);
                                } else {
                                  setActiveTab(item.target);
                                }
                              }
                            }}
                            className="w-full text-left px-4 py-2.5 text-xs font-sans font-semibold text-slate-700 hover:text-secondary hover:bg-orange-50/60 transition-colors block cursor-pointer"
                          >
                            {sub.label}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                );
              }

              // 2. Standard Link item
              const isLinkActive = activeTab === item.target || 
                (item.target === 'products' && activeTab === 'product-detail') ||
                (item.target && item.target.startsWith('products:') && activeTab === 'products');

              return (
                <button
                  key={item.id}
                  onClick={() => {
                    if (item.target && item.target.startsWith('products:')) {
                      const catName = item.target.replace('products:', '');
                      if (setSelectedProductCategory) setSelectedProductCategory(catName);
                      setActiveTab('products');
                    } else {
                      setActiveTab(item.target);
                    }
                  }}
                  className={`font-sans text-[14px] transition-colors py-1 cursor-pointer ${
                    isLinkActive ? 'text-secondary font-bold' : 'text-slate-700 hover:text-secondary font-medium'
                  }`}
                >
                  {item.label}
                </button>
              );
            })}
          </div>
        </div>

        {/* Desktop Right Actions */}
        <div className="hidden xl:flex items-center gap-6 shrink-0">
          
          <button 
            onClick={openQuoteModal}
            className="bg-secondary text-white px-5 py-2 rounded-full font-sans text-[13px] font-extrabold hover:bg-orange-600 transition-all shadow-md active:scale-95 flex items-center gap-2 cursor-pointer tracking-wide"
          >
            <span className="material-symbols-outlined text-[18px]">request_quote</span>
            <span>Get a Quote</span>
          </button>

          <div className="flex items-center gap-4">
            <button
              onClick={() => setActiveTab('india')}
              className={`font-sans text-[14px] font-bold transition-all flex items-center gap-2 cursor-pointer ${
                activeTab === 'india'
                  ? 'text-secondary'
                  : 'text-[#0f172a] hover:text-secondary'
              }`}
            >
              <div className="flex items-center justify-center w-5 h-3.5 border border-slate-200 shadow-xs overflow-hidden">
                <IndianFlagSvg />
              </div>
              <span>India</span>
            </button>

            <div className="w-px h-4 bg-slate-300"></div>

            <button 
              onClick={() => setActiveTab('support')}
              className="text-slate-700 hover:text-secondary transition-colors flex items-center cursor-pointer"
              title="Contact Support"
            >
              <span className="material-symbols-outlined text-[20px]">headset_mic</span>
            </button>
          </div>
        </div>

        {/* Mobile Actions */}
        <div className="flex xl:hidden items-center gap-2">
          <button
            onClick={() => setActiveTab('india')}
            className="px-2.5 py-1.5 rounded-lg border border-slate-200 text-xs font-sans font-bold text-slate-700 flex items-center gap-1.5"
            title="Proudly Indian"
          >
            <IndianFlagSvg />
          </button>

          <button 
            onClick={openQuoteModal}
            className="bg-secondary text-white px-3.5 py-2 rounded-lg font-sans text-xs font-bold"
          >
            RFQ
          </button>
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="p-2 text-slate-700 hover:text-secondary rounded-lg"
            aria-label="Toggle Navigation Menu"
          >
            <span className="material-symbols-outlined text-2xl">
              {mobileMenuOpen ? 'close' : 'menu'}
            </span>
          </button>
        </div>

      </nav>

      {/* Mobile Drawer Menu */}
      {mobileMenuOpen && (
        <div className="xl:hidden bg-white border-b border-slate-200 px-6 py-6 space-y-4 shadow-xl animate-fadeIn max-h-[80vh] overflow-y-auto custom-scrollbar">
          {visibleNavItems.map((item) => {
            if (item.type === 'dropdown') {
              let dropdownSubItems = (item.items || []).filter(sub => sub.visible !== false);
              if (item.id === 'products') {
                dropdownSubItems = categoriesList
                  .filter(cat => cat !== 'All')
                  .map(cat => ({
                    id: cat.toLowerCase().replace(/[^a-z0-9]+/g, '-'),
                    label: cat,
                    target: cat
                  }));
              }
              
              const isOpen = item.id === 'products'
                ? productsDropdownOpen
                : industriesDropdownOpen;

              const setIsOpen = item.id === 'products'
                ? setProductsDropdownOpen
                : setIndustriesDropdownOpen;

              const isItemActive = activeTab === item.target || 
                (item.target === 'products' && (activeTab === 'products' || activeTab === 'product-detail'));

              return (
                <div key={item.id} className="border-b border-slate-100 pb-2">
                  <div className="flex justify-between items-center py-2">
                    <button 
                      onClick={() => { setActiveTab(item.target); setMobileMenuOpen(false); }}
                      className={`font-sans text-base font-bold ${isItemActive ? 'text-secondary' : 'text-slate-800'}`}
                    >
                      {item.label}
                    </button>
                    {dropdownSubItems.length > 0 && (
                      <button 
                        onClick={() => setIsOpen(!isOpen)}
                        className="p-1 text-slate-500 hover:text-slate-800"
                      >
                        <span className="material-symbols-outlined text-sm">{isOpen ? 'expand_less' : 'expand_more'}</span>
                      </button>
                    )}
                  </div>
                  {isOpen && dropdownSubItems.length > 0 && (
                    <div className="pl-4 py-2 space-y-2 border-l-2 border-secondary/30 ml-2">
                      {dropdownSubItems.map(sub => (
                        <button
                          key={sub.id || sub.target}
                          onClick={() => {
                            const targetSlug = sub.target || sub.id;
                            let foundType = null;
                            
                            if (item.id === 'products' || (targetSlug && targetSlug.startsWith('products:'))) {
                              const catName = targetSlug.startsWith('products:') ? targetSlug.replace('products:', '') : sub.label;
                              if (setSelectedProductCategory) setSelectedProductCategory(catName);
                              setActiveTab('products');
                            } else {
                              if (industries && industries.some(i => i.slug === targetSlug || i.id === targetSlug)) {
                                if (setSelectedIndustrySlug) setSelectedIndustrySlug(targetSlug);
                                foundType = 'industries';
                              }

                              if (foundType) {
                                setActiveTab(foundType);
                              } else if (targetSlug) {
                                  setActiveTab(targetSlug);
                                } else {
                                  setActiveTab(item.target);
                                }
                            }
                            setMobileMenuOpen(false);
                          }}
                          className="w-full text-left text-xs font-sans font-medium text-slate-600 hover:text-secondary py-1"
                        >
                          {sub.label}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              );
            }

            const isLinkActive = activeTab === item.target || 
              (item.target === 'products' && activeTab === 'product-detail') ||
              (item.target && item.target.startsWith('products:') && activeTab === 'products');

            return (
              <button 
                key={item.id}
                onClick={() => {
                  if (item.target && item.target.startsWith('products:')) {
                    const catName = item.target.replace('products:', '');
                    if (setSelectedProductCategory) setSelectedProductCategory(catName);
                    setActiveTab('products');
                  } else {
                    setActiveTab(item.target);
                  }
                  setMobileMenuOpen(false);
                }}
                className={`w-full text-left font-sans text-base font-bold py-2 border-b border-slate-100 ${
                  isLinkActive ? 'text-secondary' : 'text-slate-800'
                }`}
              >
                {item.label}
              </button>
            );
          })}

          <div className="pt-4">
            <button 
              onClick={() => { openQuoteModal(); setMobileMenuOpen(false); }}
              className="w-full bg-secondary text-white py-3 rounded-xl font-sans text-sm font-bold shadow-lg"
            >
              Request Engineering Consultation
            </button>
          </div>

        </div>
      )}

    </header>
  );
};
